import { Button } from '@/components/atoms/Button';
import styled from '@emotion/styled';

export const Container = styled.div<{ error?: string; isTouched?: boolean }>`
    background: ${({ theme }) => theme.color.white200};
    border: 1px solid
        ${({ error, isTouched, theme }) => {
            if (error) {
                return theme.color.bloodyMary;
            }
            if (isTouched) {
                return theme.color.emerald;
            }
            return theme.color.grey300;
        }};
    width: 100%;
    box-sizing: border-box;
    border-radius: ${({ theme }) => theme.radius.main};
    padding: 10px 16px;
    font-size: ${({ theme }): string => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
    display: flex;
    align-items: flex-start;
    font-weight: 600;
    min-height: 40px;

    &:focus-within {
        border: 1px solid
            ${({ error, isTouched, theme }) => {
                if (error) {
                    return theme.color.bloodyMary;
                }
                if (isTouched) {
                    return theme.color.emerald;
                }
                return theme.color.black300;
            }};
    }
`;

export const IconContainer = styled.div`
    padding-left: 10px;
    margin-top: 8px;
`;

export const UnstyledTextarea = styled.textarea<{ resize?: string }>`
    border: none;
    width: 100%;
    background-image: none;
    background-color: transparent;
    box-shadow: none;
    margin: 0;
    color: ${({ theme }) => theme.color.black200};
    line-height: 1.5;
    ${({ theme }): string => theme.font.text.regular}
    font-size: ${({ theme }) => theme.font.size.normal};
    resize: ${({ resize }) => resize};
    min-height: 60px;
    font-family: inherit;

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: ${({ theme }) => theme.color.black300};
        font-size: ${({ theme }) => theme.font.size.small};
    }
`;

export const StyledButton = styled(Button)`
    margin: -6px -12px -6px 5px;
    padding: 5px 16px;
    height: 30px;
    align-self: flex-end;
`;
